import { render, staticRenderFns } from "./CatalogEdit.vue?vue&type=template&id=2fe1e451&scoped=true"
import script from "./CatalogEdit.vue?vue&type=script&lang=js"
export * from "./CatalogEdit.vue?vue&type=script&lang=js"
import style0 from "./CatalogEdit.vue?vue&type=style&index=0&id=2fe1e451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1e451",
  null
  
)

export default component.exports